import { makeAutoObservable } from 'mobx';
import { RootStore } from '../RootStore';

export class ExcelStore {
  rootStore: RootStore;
  selectedHospitalName: string | null = null;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  setSelectedHospitalName(value: string) {
    return '';
  }
}
